module.exports = __webpack_public_path__ + "media/images/landing_page/dashboard-51a383739d8ab219519962e269539be0.png";